import axios from 'axios';

export const transformWithAdapter = (adapter) => axios.defaults.transformResponse.concat(adapter);

export const getTransformOpts = (adapter) => ({ transformResponse: transformWithAdapter(adapter) });
